import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=04a389ee&scoped=true"
import script from "./NewClientModal.vue?vue&type=script&lang=js"
export * from "./NewClientModal.vue?vue&type=script&lang=js"
import style0 from "./NewClientModal.vue?vue&type=style&index=0&id=04a389ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a389ee",
  null
  
)

export default component.exports